import { ICON_SIZE } from "lib/constants";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import {
  PiCalendarCheckLight,
  PiUserPlusLight,
  PiUsersLight,
  PiCurrencyGbpLight,
  PiHospitalLight,
} from "react-icons/pi";

export const ADMIN_DASHBOARD_TILES: DashboardWidget[] = [
  {
    title: "Appointments",
    subTitle: "monthly summary",
    count: 0,
    total: 0,
    percentage: 0,
    icon: <PiCalendarCheckLight size={ICON_SIZE} />,
    path: PAGE_ROUTES.ADMIN.DashboardAppointments,
  },
  {
    title: "Clinics",
    subTitle: "monthly summary",
    count: 0,
    //total: 0,
    percentage: 0,
    icon: <PiUserPlusLight size={ICON_SIZE} />,
    path: PAGE_ROUTES.ADMIN.DashboardSubscription,
  },
  {
    title: "Subscriptions",
    subTitle: "monthly summary",
    count: 0,
    //total: 0,
    percentage: 0,
    icon: <PiUsersLight size={ICON_SIZE} />,
    path: PAGE_ROUTES.ADMIN.DashboardOccupancy,
  },
  {
    title: "Earnings",
    subTitle: "monthly summary",
    count: 0,
    percentage: 0,
    icon: <PiCurrencyGbpLight size={ICON_SIZE} />,
  },
];

export const CLINIC_WIDGETS = [
  {
    id: 0,
    title: "Clinic 1",
    count: 30,
    total: 85,
    percentage: 40,
    icon: <PiHospitalLight size={ICON_SIZE} />,
  },
  {
    id: 1,
    title: "Clinic 2",
    count: 56,
    total: 120,
    percentage: -10,
    icon: <PiHospitalLight size={ICON_SIZE} />,
  },
  {
    id: 2,
    title: "Clinic 3",
    count: 64,
    total: 120,
    percentage: 40,
    icon: <PiHospitalLight size={ICON_SIZE} />,
  },
  {
    id: 3,
    title: "Clinic 4",
    count: 530,
    percentage: 50,
    icon: <PiHospitalLight size={ICON_SIZE} />,
  },
  {
    id: 4,
    title: "Clinic 5",
    count: 30,
    total: 85,
    percentage: 40,
    icon: <PiHospitalLight size={ICON_SIZE} />,
  },
  {
    id: 5,
    title: "Clinic 6",
    count: 56,
    total: 120,
    percentage: -10,
    icon: <PiHospitalLight size={ICON_SIZE} />,
  },
  {
    id: 6,
    title: "Clinic 7",
    count: 64,
    total: 120,
    percentage: 40,
    icon: <PiHospitalLight size={ICON_SIZE} />,
  },
  {
    id: 7,
    title: "Clinic 8",
    count: 530,
    percentage: 50,
    icon: <PiHospitalLight size={ICON_SIZE} />,
  },
];
